import React from 'react';
import { Link } from 'react-router-dom';
import vineyardVideo from '../../assets2/vineyard.mp4';
import aboutBg from '../../assets2/backgrounds/about-bg.png';
import './HeroImg.css';

const HeroImg = () => {
  return (
    <div className="hero-container">
      <div className="hero-background">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="hero-bg-video"
        >
          <source src={vineyardVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <img src={aboutBg} alt="Background" className="hero-bg-img" />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            I Grow Plants
            <span className="hero-subtitle"> Smarter</span>
          </h1>
          <p className="hero-description">
            I have built a custom platform to connect with existing grow setups to manage and maintain plants sustainably and long-term. Contact us if you're interested in certain plants or have any technology or automation needs.
          </p>
          <div className="hero-buttons">
            <Link to="/demo" className="hero-btn primary">
              Watch Demo
            </Link>
            <Link to="/contact" className="hero-btn secondary">
              Join Newsletter
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroImg;
